import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

export async function shouldRequestFromUser(courseId, username) {
  const url = `${getConfig().LMS_BASE_URL}/api/extended/reviews/should-request-from-user/`;
  return getAuthenticatedHttpClient().post(url, { courseId, username });
}

export async function sendReview(courseId, rating, comment, username) {
  const url = `${getConfig().LMS_BASE_URL}/api/extended/reviews/`;
  return getAuthenticatedHttpClient().post(url, {
    courseId, rating, comment, username,
  });
}
